import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, PartyPopper } from "lucide-react";
import { api } from "@/lib/api";
import FormRenderer from "@/components/price/FormRenderer";

/** Page publique /q/:token — répondre sans être connecté. */
export default function QuestionnairePage() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true });
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/price/forms/public/${token}`)
      .then((r) => setState({ ...r.data, done: r.data.answered }))
      .catch((e) => setState({ error: e?.response?.data?.detail || "Lien invalide" }));
  }, [token]);

  const submit = async (answers) => {
    setSending(true); setError("");
    try {
      await api.post(`/price/forms/public/${token}`, { answers });
      setState((s) => ({ ...s, done: true }));
    } catch (e) { setError(e?.response?.data?.detail || "Envoi impossible"); } finally { setSending(false); }
  };

  const closed = state.form?.status === "closed";
  return (
    <div className="min-h-screen street-dots px-5 py-8" style={{ background: "hsl(15 100% 96%)" }} data-testid="questionnaire-page">
      <div className="mx-auto max-w-md">
        <div className="flex items-center gap-3">
          <img src="/price-logo-192.png" alt="Price" className="h-12 w-12 rounded-2xl" />
          <div><div className="font-[Outfit] text-[22px] font-black leading-none">Price</div><div className="text-[11px] font-bold tracking-widest text-foreground/50">COVOITURAGE</div></div>
        </div>
        {state.loading && <Loader2 className="mx-auto mt-16 h-7 w-7 animate-spin text-primary" />}
        {state.error && <Card testid="questionnaire-error">{state.error}</Card>}
        {state.form && state.done && (
          <Card testid="questionnaire-done">
            <PartyPopper className="mx-auto mb-2 h-10 w-10 text-primary" />
            <div className="font-[Outfit] text-[20px] font-black">{state.prenom ? `Merci ${state.prenom} !` : "Merci !"}</div>
            <div className="mt-1 text-[14px] text-foreground/70">Tes réponses ont bien été enregistrées.</div>
          </Card>
        )}
        {state.form && !state.done && closed && <Card testid="questionnaire-closed">Ce questionnaire est clôturé. Merci quand même !</Card>}
        {state.form && !state.done && !closed && (
          <>
            <h1 className="mt-6 font-[Outfit] text-[28px] font-black leading-tight">{state.form.title}</h1>
            {state.form.description && <p className="mt-2 text-[15px] text-foreground/70">{state.form.description}</p>}
            {error && <div className="mt-3 rounded-xl bg-red-50 p-3 text-[13px] font-bold text-red-700" data-testid="questionnaire-submit-error">{error}</div>}
            <div className="mt-5"><FormRenderer form={state.form} onSubmit={submit} submitting={sending} /></div>
          </>
        )}
      </div>
    </div>
  );
}

function Card({ children, testid }) {
  return <div className="mt-10 rounded-3xl bg-white p-6 text-center text-[15px] font-bold street-border street-shadow" data-testid={testid}>{children}</div>;
}
